import { hasFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/shared/hasFaireDirectFirstOrderIncentive";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { useCallback } from "react";
export var useFaireDirectFirstOrderIncentiveHasIncentiveFields = function(faireDirectFirstOrderIncentive) {
    var hasIncentive = hasFaireDirectFirstOrderIncentive(faireDirectFirstOrderIncentive);
    var hasIncentiveAndBrandTokenMatches = useCallback(function(brandTokenToMatch) {
        return hasIncentive && (faireDirectFirstOrderIncentive === null || faireDirectFirstOrderIncentive === void 0 ? void 0 : faireDirectFirstOrderIncentive.brand_token) === brandTokenToMatch;
    }, [
        faireDirectFirstOrderIncentive === null || faireDirectFirstOrderIncentive === void 0 ? void 0 : faireDirectFirstOrderIncentive.brand_token,
        hasIncentive
    ]);
    var isInternational = useRetailerStore([
        "isInternational"
    ]).isInternational;
    var hasIncentiveAndBrandIsBasedInCanadaOrUSA = getHasIncentiveAndBrandIsBasedInCanadaOrUSA({
        brandBasedIn: faireDirectFirstOrderIncentive === null || faireDirectFirstOrderIncentive === void 0 ? void 0 : faireDirectFirstOrderIncentive.brand_based_in,
        hasIncentive: hasIncentive,
        isInternational: isInternational
    });
    return {
        hasIncentive: hasIncentive,
        hasIncentiveAndBrandTokenMatches: hasIncentiveAndBrandTokenMatches,
        hasIncentiveAndBrandIsBasedInCanadaOrUSA: hasIncentiveAndBrandIsBasedInCanadaOrUSA
    };
};
var getHasIncentiveAndBrandIsBasedInCanadaOrUSA = function(param) {
    var brandBasedIn = param.brandBasedIn, hasIncentive = param.hasIncentive, isInternational = param.isInternational;
    var brandIsBasedInCanadaOrUSA = brandBasedIn === THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN || brandBasedIn === THREE_LETTER_PRIMARY_COUNTRY_CODES.USA;
    return hasIncentive && brandIsBasedInCanadaOrUSA && !isInternational;
};
